import enums from '../utils/enums';

import EllipsisTooltip from '../components/EllipsisTooltip.vue';
const columns = {
  Select: {
    type: 'selection',
    width: 50,
    align: 'center',
  },
  RequestCode: (title, width) => ({
    slot: 'RequestCode',
    title: title,
    width: width || 'auto',
  }),
  RequestCodeText: (title, width = 125) => ({
    key: 'RequestCode',
    title: title,
    width: width,
  }),
  MaterielNumber: (title, width, visible) => ({
    key: 'MaterielNumber',
    title: title,
    width: width || 'auto',
    render: (h, params) => {
      return h('div', params.row.MaterielNumber || 'N/A');
    },
    visible: visible === false ? false : true,
  }),
  number: title => ({
    key: 'Number',
    title: title,
  }),
  arrivalNumber: title => ({
    key: 'ArriveNumber',
    title: title,
  }),
  Price: title => ({
    key: 'Price',
    title: title,
  }),
  Applicant: (title, width) => ({
    key: 'Applicant',
    title: title,
    width: width || 'auto',
  }),
  ProcurementScheduleStatus: title => ({
    key: 'ProcurementScheduleStatusDescription',
    title: title,
  }),
  EstimatedArrival: title => ({
    key: 'EstimatedArrival',
    title: title,
  }),
  TotalPrice: title => ({
    key: 'TotalPrice',
    title: title,
    // title: title + '(￥)'
  }),
  CASNumber: (title, width, visible) => ({
    key: 'CASNumber',
    title: title,
    width: width || 'auto',
    visible: visible === false ? false : true,
  }),
  CategoryCode: title => ({
    key: 'CategoryCode',
    title: title,
  }),
  CategoryName: (title, width) => ({
    key: 'CategoryName',
    title: title,
    width: width || 'auto',
  }),
  Barcode: (title, width) => ({
    key: 'Barcode',
    title: title,
    width: width || 120,
  }),
  SubBarcode: (title, width) => ({
    key: 'SubBarcode',
    title: title,
    width: width || 120,
  }),
  BottleName: (title, width) => ({
    key: 'BottleName',
    title: title,
    width: width || 'auto',
  }),
  ChinName: (title, width, slot = 'key') => ({
    [slot]: 'ChinName',
    title: title,
    width: width || 'auto',
  }),
  chinName: (title, width) => ({
    key: 'ChinName',
    title: title,
    width: width || 'auto',
    tooltip: true,
  }),
  Purity: (title, width) => ({
    key: 'Purity',
    title: title,
    width: width || 'auto',
  }),
  RequestQuantity: (title, width) => ({
    key: 'RequestQuantity',
    title: title,
    render: (h, params) => {
      return h('div', params.row.RequestQuantity + params.row.RequestUnit);
    },
    width: width || 'auto',
  }),
  Requester: (title, width) => ({
    key: 'Requester',
    title: title,
    width: width || 'auto',
  }),
  EstimatedAmount: (title, width) => ({
    key: 'EstimatedAmount',
    title: title,
    render: (h, params) => {
      return h('div', params.row.EstimatedAmount + params.row.RequestUnit);
    },
    width: width || 'auto',
  }),
  ActualAmount: title => ({
    key: 'RequestQuantity',
    title: title,
    width: 80,
    render: (h, params) => {
      return h('div', params.row.ConsumeQuantity + params.row.RequestUnit);
    },
  }),
  InitialQuantity: title => ({
    key: 'InitialQuantity',
    title: title,
    render: (h, params) => {
      return h('div', params.row.InitialQuantity + params.row.Unit);
    },
  }),
  CurrentQuantity: title => ({
    key: 'CurrentQuantity',
    title: title,
  }),
  ProjectCode(title, width) {
    return {
      key: 'ProjectCode',
      title: title,
      width: width || 'auto',
      render: (h, params) => {
        const { ProjectOrigin, OriginProjectId } = params.row;
        const isFromPM = ProjectOrigin === 'PM';
        const href = isFromPM ? `${config.site.pm}/#/app/project?id=${OriginProjectId}` : 'javascript:void(0)';
        return h(
          'a',
          {
            attrs: {
              href,
            },
            on: {
              click: () => {
                if (!isFromPM) {
                  this.$Message.warning(this.$t('key22'));
                }
              },
            },
          },
          params.row.ProjectCode
        );
      },
    };
  },
  RequestDate: (title, width) => ({
    key: 'RequestDate',
    title: title,
    render: (h, params) => {
      return h('div', params.row.RequestDate ? params.row.RequestDate.split(' ')[0] : '');
    },
    width: width || 'auto',
  }),
  ShowState: (title, width, genRender) => ({
    key: 'ShowState',
    title: title,
    width: width || 'auto',
    render: (h, params) => {
      const { row } = params;
      const state = h('div', row.ShowState + ' ' + (row.RequestState === enums.requestState.CoasterDismissal ? message : ''));
      const reason =
        row.RequestState === enums.requestState.refusedReturn
          ? row.ReturnStockRefusedReason
          : row.RequestState === enums.requestState.refusedScrap
          ? row.ScrapRefusedReason
          : '';
      if (reason) {
        return h(
          'Tooltip',
          {
            props: {
              placement: 'top',
              content: reason,
            },
          },
          [state]
        );
      } else {
        const render = genRender && genRender(row);
        return render
          ? h(
              'div',
              {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                },
              },
              [state, render(h)]
            )
          : state;
      }
    },
  }),
  ApproveUser: (title, width) => ({
    key: 'ApproveUser',
    title: title,
    width: width || 'auto',
  }),
  ApproveTime: (title, width) => ({
    key: 'ApproveTime',
    title: title,
    width: width || 100,
    render: (h, params) => {
      return h('div', params.row.ApproveTime ? params.row.ApproveTime.split(' ')[0] : '');
    },
  }),
  ApproveReason: (title, width) => ({
    key: 'ApproveReason',
    title: title,
    width: width || 100,
  }),
  ApplyTime: (title, width) => ({
    key: 'ApplyTime',
    title: title,
    width: width || 'auto',
    render: (h, params) => {
      return h('div', params.row.ApplyTime ? params.row.ApplyTime.split(' ')[0] : '');
    },
  }),
  CompleteTime: title => ({
    key: 'CompleteTime',
    title: title,
    width: 100,
    render: (h, params) => {
      return h('div', params.row.CompleteTime ? params.row.CompleteTime.split(' ')[0] : '');
    },
  }),
  bfTime: (title, width) => ({
    key: 'CompleteTime',
    title: title,
    width: 100,
    render: (h, params) => {
      return h('div', params.row.CompleteTime ? params.row.CompleteTime.split(' ')[0] : '');
    },
  }),
  tkComments: (title, width, genRender) => ({
    key: 'Comments',
    title: title,
    width: width || 'auto',
    render: (h, params) => {
      const { row } = params;
      const comments = row.Comments;
      const render = genRender && genRender(row);
      return render
        ? h(
            'div',
            {
              style: {
                display: 'flex',
                alignItems: 'center',
              },
            },
            [comments, render(h)]
          )
        : comments;
    },
  }),
  bfComments: (title, width, genRender) => ({
    key: 'Comments',
    title: title,
    width: width || 'auto',
    render: (h, params) => {
      const { row } = params;
      const comments = row.Comments;
      const render = genRender && genRender(row);
      return render
        ? h(
            'div',
            {
              style: {
                display: 'flex',
                alignItems: 'center',
              },
            },
            [comments, render(h)]
          )
        : comments;
    },
  }),
  Comment: (title, width, slot = 'key', visible) => ({
    [slot]: 'Comment',
    title: title,
    width: width || 'auto',
    visible: visible === false ? false : true,
  }),
  Purpose: (title, width, slot = 'key') => ({
    [slot]: 'Purpose',
    title: title,
    width: width || 'auto',
  }),
  ApproveUsersNames: (title, width) => ({
    key: 'ApproveUsersNames',
    title: title,
    width: width || 'auto',
    tooltip: true,
  }),
  applicantApproveTime: title => ({
    key: 'ApproveTime',
    title: title,
    width: 90,
    render: (h, params) => {
      return h('div', params.row.ApproveTime ? params.row.ApproveTime.split(' ')[0] : '');
    },
  }),
  StorageLocation: (title, width) => ({
    key: 'StorageLocation',
    title: title,
    width: width || 'auto',
  }),
  Deliverer: title => ({
    key: 'Deliverer',
    title: title,
    width: 80,
  }),
  ExpectationPeriod: (title, visible) => ({
    key: 'ExpectationPeriod',
    title: title,
    width: 90,
    visible: visible === false ? false : true,
  }),
  storeInfo: title => ({
    slot: 'storeInfo',
    title: title,
    align: 'center',
  }),
  ReceiveDate: (title, width) => ({
    key: 'ReceiveDate',
    title: title,
    width: width || 100,
    render: (h, params) => {
      let receiveDate = params.row.DeliveryFlag === 1 ? params.row.SelfReceiveDate : params.row.ReceiveDate;
      let date = receiveDate ? receiveDate.split(' ')[0] : '';
      return h('div', date);
    },
  }),
  Action: (title, width, slot = 'key', slotName = 'Action', fixed = undefined) => ({
    slot: slotName,
    title: title,
    align: 'center',
    width: width || 210,
    fixed,
  }),
  Action1: (title, width) => ({
    slot: 'Action1',
    title: title,
    align: 'center',
    width: width || 'auto',
  }),
  RequestAction: (title, width) => ({
    slot: 'RequestAction',
    title: title,
    align: 'center',
    width: 70,
  }),
  Radio: {
    slot: 'Radio',
    title: ' ',
    align: 'center',
    width: 70,
  },
  Specifications: (title, width) => ({
    key: 'Specifications',
    title: title,
    width: width || 'auto',
    render: (h, params) => {
      return h('div', params.row.SpecificationsText || params.row.Specifications);
    },
  }),
  Lab: title => ({
    key: 'Lab',
    title: title,
  }),
  Phone: title => ({
    key: 'Phone',
    title: title,
  }),
  WarehouseName: (title, width = 'auto', visible = true) => ({
    key: 'WarehouseName',
    title: title,
    width: width,
    visible: visible,
  }),
  ExpiryDate: title => ({
    key: 'ExpiryDate',
    title: title,
  }),
  CreateUser: title => ({
    key: 'CreateUser',
    title: title,
  }),
  CreateTime: title => ({
    key: 'CreateTime',
    title: title,
  }),
  BottleType: title => ({
    key: 'BottleType',
    title: title,
  }),
  PONumber: title => ({
    key: 'PONumber',
    title: title,
  }),
  LotNumber: (title, width, visible = true) => ({
    key: 'LotNumber',
    title: title,
    width: width || 'auto',
    visible: visible,
  }),
  Sublocation: title => ({
    key: 'Sublocation',
    title: title,
  }),
  ApproveStateName: title => ({
    key: 'ApproveStateName',
    title: title,
  }),
  UnitPrice: (title, width) => ({
    key: 'UnitPrice',
    title: title,
    width: width || 'auto',
    render: (h, params) => {
      return h('div', '￥' + params.row.UnitPrice);
    },
  }),
  PerWeightPrice: (title, width) => ({
    key: 'PerWeightPrice',
    title: title,
    width: width || 70,
    render: (h, params) => {
      const { PerWeightPrice } = params.row;
      return PerWeightPrice ? h('div', '￥' + PerWeightPrice) : '';
    },
  }),
  IsSettleAccounts: (title, label1, label2) => ({
    key: 'IsSettleAccounts',
    title: title,
    width: 80,
    render: (h, params) => {
      return h('div', params.row.IsSettleAccounts ? label1 : label2);
    },
  }),
  ControlType: (title, width) => ({
    key: 'ControlType',
    title: title,
    width: width || 'auto',
    render: (h, params) => {
      const warningKeys = enums.controlType;
      const imgs = warningKeys
        .filter(key => params.row[key])
        .map(key => {
          return h('img', {
            attrs: {
              src: require(`@/assets/img/${key}.png`),
            },
            style: {
              width: '30px',
              marginRight: '3px',
            },
          });
        });

      return h(
        'div',
        {
          style: {
            paddingTop: '8px',
          },
        },
        imgs
      );
    },
  }),
  RefusedUser: (title, width) => ({
    key: 'RefusedUser',
    title: title,
    width: width || 70,
  }),
  RefusedDate: (title, width) => ({
    key: 'RefusedDate',
    title: title,
    width: width || 90,
  }),
  RefusedReason: (title, width) => ({
    key: 'RefusedReason',
    title: title,
    width: width || 'auto',
    render(h, params) {
      return h(EllipsisTooltip, {
        props: {
          content: params.row.RefusedReason,
        },
      });
    },
  }),
  EndReason: (title, width) => ({
    key: 'EndReason',
    title: title,
    width: width || 'auto',
    render(h, params) {
      return h(EllipsisTooltip, {
        props: {
          content: params.row.EndReason,
        },
      });
    },
  }),
  Producer: (title, width) => ({
    key: 'Producer',
    title: title,
    width: width || 'auto',
  }),
  CatalogNumber: (title, width, visible) => ({
    key: 'CatalogNumber',
    title: title,
    width: width || 'auto',
    visible: visible === false ? false : true,
  }),
  POComment: (title, width) => ({
    key: 'POComment',
    title: title,
    width: width || 'auto',
  }),
  Origin: (title, width) => ({
    key: 'Origin',
    title: title,
    width: width || 'auto',
  }),
  GrossWeight: (title, width) => ({
    key: 'GrossWeight',
    title: title,
    width: width || 'auto',
  }),
  PoNumber: (title, width) => ({
    key: 'PoNumber',
    title: title,
    width: width || 'auto',
  }),
  Supplier: (title, width, visible = true) => ({
    key: 'Supplier',
    title: title,
    width: width || 'auto',
    visible: visible,
  }),
  get(key, title, visible, width) {
    return {
      key: key,
      title: title,
      visible: visible,
      width: width || 'auto',
    };
  },
  remainArrivals: title => ({
    slot: 'remainArrivals',
    title: title,
  }),
  CancelReason: (title, width) => ({
    key: 'CancelReason',
    title: title,
    width: width || 'auto',
    render(h, params) {
      return h(EllipsisTooltip, {
        props: {
          content: params.row.CancelReason,
        },
      });
    },
  }),
  ApproveResult: (title, width) => ({
    key: 'PoNumber',
    title: title,
    width: width || 'auto',
  }),
  PurchaseCode: (title, width) => ({
    key: 'PurchaseCode',
    title: title,
    width: width || 'auto',
    render(h, params) {
      return h(
        'a',
        {
          attrs: {
            href: `/applicant/detail?id=${params.row.ID}`,
          },
        },
        params.row.PurchaseCode
      );
    },
  }),
  StorageCondition: (title, width, visible) => ({
    key: 'StorageConditionText',
    title: title,
    width: width || 'auto',
    visible: visible || false,
  }),
  // 接收人
  Receiver: (title, width) => ({
    key: 'Receiver',
    title: title,
    width: width || 'auto',
  }),
};

export default columns;
